export class ResourceNameFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "contains",
            "baseName": "contains",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notContains",
            "baseName": "notContains",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "startsWith",
            "baseName": "startsWith",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notStartsWith",
            "baseName": "notStartsWith",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "endsWith",
            "baseName": "endsWith",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notEndsWith",
            "baseName": "notEndsWith",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceNameFilters.attributeTypeMap;
    }
    constructor() {
    }
}
